<template lang="pug">
	.modal-card.calibrateSensorContainer(v-if="permissions.indexOf('calibrate:sensor') > -1"): .modal-card-body
		h1.title Calibrate Sensor
		b-select(v-model="selectedDevice", :disabled="userDevices.length < 2")
			option(v-for="device in userDevices", :key="device", :value="device") {{ device }}
		p Choose an option:
		p: strong: a(@click="offsetCalibration('high')") The temperature reading is too high.
		p: strong: a(@click="offsetCalibration('low')") The temperature reading is too low.
		p.spacer
		div.buttons(v-if="permissions.indexOf('dev:sensor') > -1")
			b-button(@click="directCalibration") Direct Calibration
			b-button(@click="allowAllMeasurements" disabled) Disable Low Filter
</template>

<style lang="scss" scoped>
	.modal-card-body {
		border-radius: 6px;

		p:not(.spacer) {
			margin-bottom: 1rem;
		}
	}
</style>

<script>
	import { mapState } from "vuex";
	import apiService from "@/services/apiService.js";

	export default {
		data() {
			return {
				selectedDevice: null // which device to calibrate
			};
		},
		computed: {
			...mapState(["user", "permissions"]),
			userDevices() {
				return this.user.devices;
			}
		},
		methods: {
			// Temperature reading too high, lower it (direction === "high") OR Temperature reading too low, raise it (direction === "low")
			offsetCalibration(direction) {
				this.$buefy.snackbar.open({
					duration: 3000,
					message: "This functionality has been disabled for the demo.",
					type: "is-warning",
					position: "is-top-right",
					queue: false
				});
				// apiService.calibrateSensor(this.selectedDevice, direction);
				this.$parent.close();
			},
			// Calibration: Calibrate Sensor Directly
			directCalibration() {
				this.$buefy.dialog.prompt({
					message: `Offset:`,
					inputAttrs: {
						placeholder: "6.5"
					},
					trapFocus: true,
					onConfirm: (value) => {
						this.$buefy.snackbar.open({
							duration: 3000,
							message: "This functionality has been disabled for the demo.",
							type: "is-warning",
							position: "is-top-right",
							queue: false
						});
						// apiService.calibrateSensorDirect(this.selectedDevice, Number(value));
						this.$parent.close();
					}
				});
			},
			// Calibration: Allow All Measurements, even below 96.0 (for debugging)
			allowAllMeasurements() {
				this.$store.commit("SET_ALLOW_ALL_MEASUREMENTS");
				this.$parent.close();
			}
		},
		mounted() {
			// Select default device in dropdown
			this.selectedDevice = this.userDevices[0];
		}
	};
</script>
